<script setup>
import { ref, onMounted } from 'vue'
import { get_notifications } from '@/services/notifications';
import { parse_meta_key } from '@/helper';
import notificationItem from './notificationItem.vue'

const isLoading = ref(false)
onMounted(async()=>{
  isLoading.value = true
  await fetch_notifications()
  isLoading.value = false
})

const notifications = ref([])
const showNotifications = ref([])
async function fetch_notifications(){
  let response = await get_notifications()
  if(!response.error){
    notifications.value = parse_notification_response(response.result.data.data, response.result.data.included)
    showNotifications.value = [...notifications.value]
  }
}

function parse_notification_response(response, included){
  let tempNotifications = response.map(notification => {
    let entity_type = included
                      .filter(item => item.type == 'entity_type')
                      .find(item => item.id == notification.attributes.entity_type_id)
    let actor = included
                      .filter(item => item.type == 'user')
                      .find(item => item.id == notification.attributes.actor_id)
    let meta = parse_meta_key(included.filter(item => item.type == 'notification_metum' && item.attributes.notification_id == notification.id))
    return {
      ...notification,
      entity_type,
      actor,
      meta
    }
  })
  return tempNotifications
}

const filters = ref([
  {
    name: 'All',
    value: null,
    active: true
  },
  {
    name: 'Read',
    value: true,
    active: false
  },
  {
    name: 'Unread',
    value: false,
    active: false
  }
])

function filter_notifications(filter){
  filters.value.map(item => item.active = false)
  filter.active = true
  if (filter.value == true){
    showNotifications.value = notifications.value.filter(item => item.attributes.seen_by_user == true)
  }else if (filter.value == false){
    showNotifications.value = notifications.value.filter(item => item.attributes.seen_by_user == false)
  }else if (filter.value == null){
    showNotifications.value = notifications.value
  }
}

const date = ref({to: '', from: ''})
async function filterDate(){
  let params = {
    date_from: date.value.from,
    date_to: date.value.to
  }
  let response = await get_notifications(params)
  if(!response.error){
    notifications.value = parse_notification_response(response.result.data.data, response.result.data.included)
    showNotifications.value = [...notifications.value]
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Activity"/>

    <div class="card">
      <div class="card-body row">
        <div class="col-12 col-md-3">
          <label class="form-label">From</label>
          <input 
            class="form-control digits" 
            type="date" 
            placeholder="2018-01-01"
            v-model="date.from"
          >
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">To</label>
          <input 
            class="form-control digits" 
            type="date" 
            placeholder="2018-01-01"
            v-model="date.to"
          >
        </div>
        <div class="col-12 col-md-3 align-content-end mb-1">
          <button class="btn btn-light-success"
            @click="filterDate()"
          >
            Filter
          </button>
        </div>
      </div>
    </div>
    <!-- Filter -->
    <div class="d-flex mb-2">
      <button v-for="filter in filters" 
        class="btn rounded-pill btn-light-primary me-2"
        :class="[{'active': filter.active}]"
        @click="filter_notifications(filter)"
      >
        {{ filter.name }}
      </button>
    </div>

    <LoadingCard v-if="isLoading" />
    <div v-else class="row">
      <div class="card">
        <div class="card-body">
          <template v-if="showNotifications.length == 0">
            <EmptyCard />
          </template>
          <template v-else>
            <div v-for="notification in showNotifications" :key="notification.id" 
              class="card no-shadow border px-3 py-2 mb-2" v-auto-animate
              :class="
                notification.attributes.seen_by_user ? 'light-card border-warning' : 'border-success'"
            >
              <notificationItem :notification="notification" />
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>